import React, { Component } from "react";
import { gotProperty } from "../../../../utils/utility";
import { connect } from "react-redux";
import { Input } from "reactstrap";
import { getVenues } from "../../../../actions/eventActions";
import { onUpdateFilters } from "../../../../actions/filterActions";


class PendingFilters extends Component {
  state = {
    venues: [],
    staff: [],
  };

  componentDidMount() {
    const _this = this;
    const { getVenues } = this.props;
    getVenues({
      onSuccess: function (venues) {
        _this.setState({
          venues,
        });
      },
      onError: function (error) {
        console.error(error);
      },
    });
  }

  /**
   * Transform values
   * @param {*} options
   * @returns
   */
  transformValue = (options) => {
    let transformValues = [];
    if ((options || []).length > 0) {
      transformValues = (options || []).map((option) => {
        let { first_name, id, last_name } = option || {};
        const name = first_name + " " + last_name;
        return {
          title: name,
          value: id,
        };
      });
    }
    return transformValues;
  };

  render() {
    const { searchFilters } = this.props.filter;
    const { venues, staff } = this.state;

    return (
      <>
        <div className="form-group">
          <label htmlFor="event-name">Event Name</label>
          <input
            type="text"
            id="event-name"
            placeholder="Event Name ..."
            className="form-control"
            value={
              gotProperty(searchFilters, "event_name")
                ? searchFilters["event_name"]
                : ""
            }
            onChange={(e) => {
              this.props.onUpdateFilters("event_name", e.target.value);
            }}
          />
        </div>

        

        <div className="form-group">
          <label htmlFor="event-venue">Venue</label>
          <Input
            type="select"
            name="select"
            id="event-venue"
            value={
              gotProperty(searchFilters, "venue_id")
                ? searchFilters["venue_id"]
                : ""
            }
            onChange={(e) => {
              this.props.onUpdateFilters("venue_id", e.target.value);
            }}
          >
            <option value="">Select Venue</option>
            {(venues || []).map((venue, index) => {
              return (
                <option key={index} value={venue.id}>
                  {venue.venue}
                </option>
              );
            })}
          </Input>
        </div>

        
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  filter: state.filter,
});

export default connect(mapStateToProps, {
  getVenues,
  onUpdateFilters,
})(PendingFilters);
